"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowButtonSet = /** @class */ (function (_super) {
    __extends(CardRowButtonSet, _super);
    function CardRowButtonSet(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowButtonSet.prototype.onGoBackClick = function (e) {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    CardRowButtonSet.prototype.onLoadClick = function (e) {
        if (this.props.onLoadClick) {
            this.props.onLoadClick();
        }
    };
    CardRowButtonSet.prototype.onFillClick = function (e) {
        if (this.props.onFillClick) {
            this.props.onFillClick();
        }
    };
    CardRowButtonSet.prototype.onPreviewClick = function (e) {
        if (this.props.onPreviewClick) {
            this.props.onPreviewClick();
        }
    };
    CardRowButtonSet.prototype.onAddClick = function (e) {
        if (this.props.onAddClick) {
            this.props.onAddClick();
        }
    };
    CardRowButtonSet.prototype.onEditClick = function (e) {
        if (this.props.onEditClick) {
            this.props.onEditClick();
        }
    };
    CardRowButtonSet.prototype.GetButtonSet = function () {
        var _ret = [];
        if (this.props.title.btnGoBack) {
            _ret.push(React.createElement(antd_1.Button, { key: 0, ghost: true, style: { width: "180px" }, type: "primary", onClick: this.onGoBackClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "rollback" }),
                this.props.title.btnGoBack));
        }
        if (this.props.title.btnLoad) {
            _ret.push(React.createElement(antd_1.Button, { key: 1, ghost: true, style: { width: "180px" }, type: "primary", onClick: this.onLoadClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "cloud-download" }),
                this.props.title.btnLoad));
        }
        if (this.props.title.btnFill) {
            _ret.push(React.createElement(antd_1.Button, { key: 2, ghost: true, style: { width: "120px" }, type: "primary", onClick: this.onFillClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "select" }),
                this.props.title.btnFill));
        }
        if (this.props.title.btnPreview) {
            _ret.push(React.createElement(antd_1.Button, { key: 3, ghost: true, style: { width: "120px" }, type: "primary", onClick: this.onPreviewClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "monitor" }),
                this.props.title.btnPreview));
        }
        if (this.props.editMode) {
            if (this.props.title.btnEdit) {
                _ret.push(React.createElement(antd_1.Button, { key: 4, ghost: true, style: { width: "180px" }, type: "primary", onClick: this.onEditClick.bind(this) },
                    React.createElement(antd_1.Icon, { type: "check" }),
                    this.props.title.btnEdit));
            }
        }
        else {
            if (this.props.title.btnNew) {
                _ret.push(React.createElement(antd_1.Button, { key: 4, ghost: true, style: { width: "180px" }, type: "primary", onClick: this.onAddClick.bind(this) },
                    React.createElement(antd_1.Icon, { type: "file" }),
                    this.props.title.btnNew));
            }
        }
        return _ret;
    };
    CardRowButtonSet.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement(antd_1.Button.Group, null, this.GetButtonSet())));
    };
    return CardRowButtonSet;
}(React.Component));
exports.default = CardRowButtonSet;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowButtonSet.tsx
// module id = 10
// module chunks = 0